import { commonjsGlobal as g, getDefaultExportFromCjs as y } from "../../_virtual/_commonjsHelpers.js";
import { __module as i } from "../../_virtual/base64.js";
/*! https://mths.be/base64 v1.0.0 by @mathias | MIT license */
i.exports;
(function(l, E) {
  (function(b) {
    var v = E, C = l && l.exports == v && l, s = typeof g == "object" && g;
    (s.global === s || s.window === s) && (b = s);
    var A = function(r) {
      this.message = r;
    };
    A.prototype = new Error(), A.prototype.name = "InvalidCharacterError";
    var F = function(r) {
      throw new A(r);
    }, o = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", m = /[\t\n\f\r ]/g, p = function(r) {
      r = String(r).replace(m, "");
      var t = r.length;
      t % 4 == 0 && (r = r.replace(/==?$/, ""), t = r.length), (t % 4 == 1 || // http://whatwg.org/C#alphanumeric-ascii-characters
      /[^+a-zA-Z0-9/]/.test(r)) && F(
        "Invalid character: the string to be decoded is not correctly encoded."
      );
      for (var c = 0, a, n, h = "", d = -1; ++d < t; )
        n = o.indexOf(r.charAt(d)), a = c % 4 ? a * 64 + n : n, c++ % 4 && (h += String.fromCharCode(
          255 & a >> (-2 * c & 6)
        ));
      return h;
    }, w = function(r) {
      r = String(r), /[^\0-\xFF]/.test(r) && F(
        "The string to be encoded contains characters outside of the Latin1 range."
      );
      for (var t = r.length % 3, c = "", a = -1, n, h, d, e, S = r.length - t; ++a < S; )
        n = r.charCodeAt(a) << 16, h = r.charCodeAt(++a) << 8, d = r.charCodeAt(++a), e = n + h + d, c += o.charAt(e >> 18 & 63) + o.charAt(e >> 12 & 63) + o.charAt(e >> 6 & 63) + o.charAt(e & 63);
      return t == 2 ? (n = r.charCodeAt(a) << 8, h = r.charCodeAt(++a), e = n + h, c += o.charAt(e >> 10) + o.charAt(e >> 4 & 63) + o.charAt(e << 2 & 63) + "=") : t == 1 && (e = r.charCodeAt(a), c += o.charAt(e >> 2) + o.charAt(e << 4 & 63) + "=="), c;
    }, f = {
      encode: w,
      decode: p,
      version: "1.0.0"
    };
    if (v && !v.nodeType)
      if (C)
        C.exports = f;
      else
        for (var x in f)
          f.hasOwnProperty(x) && (v[x] = f[x]);
    else
      b.base64 = f;
  })(g);
})(i, i.exports);
var T = i.exports;
const I = /* @__PURE__ */ y(T);
export {
  I as default
};
